<!--
Componente per wrappare vSelect2 e permetterne il refresh dinamico.

Parametri che si ricevono dalla vista dove viene richiamato il componente:
    PARAMETRO                                 TIPOLOGIA         REQUIRED      DEFAULT             DESCRIZIONE
    event_to_listen                           String            TRUE          no default          Evento su cui rimanere in ascolto per il refresh della vSelect2
    data_ajax_url                             String            TRUE          no default          Url per il recupero dei dati della vSelect2
    data_ajax_url_keys                        Array             TRUE          no default          Parametri da aggiungere a dataAjaxUrl
    vselect2_name                             String            TRUE          no default          Name della select2 (esempio 'guest[asl_id]')
    vselect2_id                               String            TRUE          no default          ID della select2 (esempio 'guest_asl_id')

Oltre a quelli elencati sopra, vanno passati al componente anche i parametri standard della vSelect2.
-->

<template>
  <div>
    <v-select2 :key="upgrade" :name="vselect2_name" :id="vselect2_id" :options-list="optionsList" v-bind="vselect2_props" />
  </div>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import vSelect2 from './vSelect2.vue';

export default {
  name: 'vSelect2Wrapper',
  components: {
    vSelect2,
  },
  props: {
    event_to_listen: { type: String, required: true },
    data_ajax_url: { type: String, required: true },
    data_ajax_url_keys: { type: Array, required: true },
    vselect2_name: { type: String, required: true },
    vselect2_id: { type: String, required: true },
    vselect2_default_props: { type: Object }, // ':vselect2_default_props' => '{ disabled: true }'
  },
  data() {
    return {
      data_ajax_url_values: {},
      optionsList: [],
      value: null,
      upgrade: true,
    };
  },
  watch: {
    optionsList: {
      handler(val, oldVal) {
        if (oldVal.length === 0) {
          eventBus.$on(this.event_to_listen, (event) => {
            this.data_ajax_url_values = {};
            for (let i = 0; i < this.data_ajax_url_keys.length; i++) {
              this.data_ajax_url_values[this.data_ajax_url_keys[i]] = event.detail[this.data_ajax_url_keys[i]];
            }
            this.loadOptionsList();
            this.upgrade = !this.upgrade;
            setTimeout(() => {
              $(`#${this.vselect2_id}`).trigger('change');
            }, 1200);
          });
        }
      },
    },
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    dataAjaxUrl() {
      let data_ajax_url_params = '';

      for (let i = 0; i < this.data_ajax_url_keys.length; i++) {
        const data_ajax_url_key = this.data_ajax_url_keys[i];
        if (this.data_ajax_url_values[data_ajax_url_key]) {
          data_ajax_url_params += `${data_ajax_url_params == '' ? '?' : '&'}${data_ajax_url_key}=${this.data_ajax_url_values[data_ajax_url_key]}`;
        }
      }

      return `${this.data_ajax_url}${data_ajax_url_params}`;
    },
    optionsListIncludeOriginalValue() {
      if (!this.vselect2_default_props.value) {
        return false;
      }
      for (let i = 0; this.optionsList[i] != null; i++) {
        if (this.vselect2_default_props.value == this.optionsList[i][1]) {
          return true;
        }
      }
      return false;
    },
    vselect2_props() {
      let vselect2_props = this.vselect2_default_props ? { ...this.vselect2_default_props } : {};
      if (!vselect2_props.value || !this.optionsListIncludeOriginalValue) {
        vselect2_props.value = this.value;
      }
      return vselect2_props;
    },
  },
  methods: {
    loadOptionsList() {
      apiConnector()
        .get(this.dataAjaxUrl)
        .then(({ data }) => {
          this.optionsList = [[this.i18nJS.clic_per_selezionare, null], ...data];
          const default_options = this.vselect2_default_props.default_options;
          if (default_options && default_options.length && !this.optionsList.find((opt) => opt[1] == default_options[1])) {
            this.optionsList = [default_options, ...this.optionsList];
          }
          this.value = data.length > 0 ? this.optionsList[0][1] : null;
        })
        .catch((err) => {
          console.error('qualcosa non ha funzionato', err);
        });
    },
  },
  mounted() {
    const default_options = this.vselect2_default_props.default_options;
    if (default_options && default_options.length && !this.optionsList.find((opt) => opt[1] == default_options[1])) {
      this.optionsList = [default_options];
    } else {
      this.optionsList = [];
    }
  },
};
</script>
